import React from 'react';

function toPoint(p) {
    if (p == null) {
        return null;
    }
    if (Array.isArray(p)) {
        return { x: p[0], y: p[1] };
    }
    return { x: p.x, y: p.y };
}

function buildZigZagPoints(x, y, x2, y2) {
    if (x == null || y == null || x2 == null || y2 == null) {
        return [];
    }
    if (x === x2 || y === y2) {
        return [{ x, y }, { x: x2, y: y2 }];
    }
    const mx = (x + x2) / 2;
    return [
        { x, y },
        { x: mx, y },
        { x: mx, y: y2 },
        { x: x2, y: y2 },
    ];
}

function SvgPolyLine({ id, points, x, y, x2, y2 }) {
    const pts = (points && points.length >= 2)
        ? points.map(toPoint).filter(Boolean)
        : buildZigZagPoints(x, y, x2, y2);

    if (pts.length < 2) {
        return null;
    }

    const d = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x} ${p.y}`).join(' ');

    return (<svg id={id} xmlns="http://www.w3.org/2000/svg" overflow="visible">
        <defs>
            <filter id={"glow" + id} x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="5" result="blur" />
                <feFlood floodColor="#32CD32" floodOpacity="0.5" result="glowColor" />
                <feComposite in="glowColor" in2="blur" operator="in" result="coloredBlur" />
                <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        <path id={"motionPath" + id} d={d} fill="none" stroke="lightgray" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />

        <circle cx="0" cy="0" r="4" fill="#1d80b5" filter={"url(#glow" + id + ")"}>
            <animateMotion dur="3s" repeatCount="indefinite">
                <mpath href={"#motionPath" + id} />
            </animateMotion>
        </circle>
    </svg>)
}

export default SvgPolyLine
